/**
 * @file 常量 - 腾讯云
 * @author hardylin <hardylin@tencent.com>
 */
const BUCKEY = {
    DOUJIN: 'tongren-1259052908',
    OSSWEB: 'sy-ossweb-1259052908',
    TGL: 'tgl-images-1254960240',
    V4ITEA: 'sy-v4-1259052908',
    V4: 'sy-v4-shp-1259052908',
    VOD: 'sy-vod-1259052908',
}

export {
    BUCKEY
}